import { Box, colors, Grid, Typography } from '@mui/material'
import React from 'react'

const ReportFilterHeader = ({ reportTitle = '', reportTitle1 = '', reportFilterCol = [], filterData = {} }) => {
    const typographyStyle = {
        color: '#000000',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontStyle: 'Medium',
        fontSize: '14px',
        lineHeight: '100%',
        letterSpacing: '0%',
        textTransform: 'capitalize'

    }
    return (
        <Box sx={{ paddingX: '16px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
                <Typography
                    sx={{
                        fontFamily: 'Inter',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: '28px',
                        letterSpacing: '0.02em',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        color: '#000000'
                    }}
                >
                    KARNATAKA STATE ROAD TRANSPORT CORPORATION
                </Typography>
                <Typography sx={{
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    fontSize: '14px',
                    lineHeight: '100%',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    color: '#000000'
                }}>
                    {reportTitle}
                </Typography>
                {reportTitle1 !== '' &&
                    <Typography sx={{
                        fontFamily: 'Inter',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '100%',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        color: '#000000'
                    }}>
                        {reportTitle1}
                    </Typography>
                }
            </Box >
            <Grid container rowSpacing={'6px'}>
                {reportFilterCol.map((col, index) => (
                    <Grid item xs={12} sm={6} key={index} sx={{ textAlign: index % 2 === 0 ? "left" : "right" }}>
                        <Typography sx={{ typographyStyle }}>
                            <span>{col.label}</span>
                            <span>{" "}:{" "}</span>
                            <span>{filterData[col.field] ?? '-'}</span>
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Box >
    )
}

export default ReportFilterHeader